import { MenuItem, MenuList, mergeClasses, useArrowNavigationGroup } from "@fluentui/react-components";
import React, { use, useMemo } from "react";

import { SearchContext } from "./SearchStore";
import { observer } from "mobx-react";
import { useStyles } from "./M365PulseSearchBox.styles";
import { useSearchResultKeyDown } from "./useSearchResultKeyDown";

interface M365PulseSearchBoxPopoverProps {
    className: string;
    activeIndex: number;
    searchResultsId: string;
}

const M365PulseSearchBoxPopoverBase = ({ className, activeIndex, searchResultsId }: M365PulseSearchBoxPopoverProps) => {
    const store = use(SearchContext);
    const arrowNavigationAttributes = useArrowNavigationGroup({ axis: "vertical", circular: true });
    const classNames = useStyles();
    const activeMenuItemClass = classNames.activeMenuItem;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const enhancedSearchResults = useMemo(() => (store ? store.getEnhancedSearchResults() : []), [store?.searchResultList]);

    const onMenuItemKeyDown = useSearchResultKeyDown();

    return (
        <MenuList role="presentation" aria-labelledby={undefined} {...arrowNavigationAttributes}>
            {enhancedSearchResults.map((item, index) => {
                const isActive = index === activeIndex;
                const menuItemClassName = isActive ? mergeClasses(className, activeMenuItemClass) : className;
                return (
                    <MenuItem
                        key={item.id}
                        id={`${searchResultsId}-opt-${index}`}
                        onClick={item.onClick}
                        onKeyDown={(e) => onMenuItemKeyDown(e, item)}
                        className={menuItemClassName}
                        role="option"
                        tabIndex={-1}
                        aria-selected={isActive}
                        aria-posinset={index + 1}
                        aria-setsize={enhancedSearchResults.length}
                        aria-keyshortcuts={item.deleteItemFromHistory ? "Delete" : undefined}
                    >
                        {item.onRender?.() ?? item.title}
                    </MenuItem>
                );
            })}
        </MenuList>
    );
};

export const M365PulseSearchBoxPopover = observer(M365PulseSearchBoxPopoverBase);
